<ng-container>
  <button type="button" class="downloadRight" name="download" (click)="generateCSV()">
    <img src="assets/images/download-svgrepo-com.svg" width="20" height="20" title="Download Page"></button>
 
</ng-container>
<div *ngIf="!(accessType==='None')">
<input type="text" value="" class="heightzero" #clipboardInput>
<div class="tabcontainer">
  <div class="searchBlock">
    <div class="searchSection">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput id="searchAllElementsText" class="search-components textBox" type="text" placeholder="Search Pages here..."
          [(ngModel)]="str" (keydown)="onKeydown($event, listingInput)" (focus)="searchFocus = true"
          (focusout)="searchFocus = false" autofocus />
      </div>
    </div>
    <div class="filterSection spImg">
      <i class="icon-filter"></i>
      <div class="fliterBlock">
        
        <ul class="filterOption">
          <ng-container *ngIf="filterList && facets">
            <ng-container *ngFor="let filter of filterList;let i = index">
              <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                  [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
              </li>
              <span #moreButtonEl tabindex="0"
                [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                (click)="(showMore = !showMore)"
                *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="closebg"></div>
  </div>


    <div class="headingsList">
      <ul>
        <ng-container *ngFor="let header of headerList">
          <li [class]="header.class">{{header.name}}</li>
        </ng-container>
      </ul>
    </div>
    <div class="contentList">
      <ng-template #loading>
        <div style="text-align: center; display: inline-block; width: 100%;">
          <ng-container *ngIf="callFail">
            <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
              Sorry, Server Error
            </div>
          </ng-container>
          <ng-container *ngIf="!callFail">
            <div class="imagepreloader">
              <div class="a" style="--n: 5;">
                <div class="dot dot1" style="--i: 0;"></div>
                <div class="dot dot2" style="--i: 1;"></div>
                <div class="dot dot3" style="--i: 2;"></div>
                <div class="dot dot4" style="--i: 3;"></div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <ng-template #nores>
        <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
      </ng-template>
      <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
      <ng-template #listData>
        <ng-container *ngIf="listArray.length > 0;else loading">
          <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">

            <div #dive [class]="(checkFocusInside(dive)) ? 'storyListing focused' : 'storyListing'">
              <div class='story_status'>
                <em #unlockDropdown [id]="item.status" [class]="getclassonCondition(item.lockedByUserId, item.status)"
                (click)="openOptions(i)">
                <div class="arrow_box single" *ngIf="(item.lockedByUserId && unlockOptions !== i)">
                  {{item.lockedByUserName}}</div>
                </em>
              </div>


              <ul [class.active]="!item.lockedByUserId" class="listingul"  #listData2>
                <a #listEl tabindex="0"
                  [routerLink]="routeLinkForList + '/' + item.id"
                  [queryParams]="{ 'domain': domain }">

                  <li class="name">
                    <small [title]="item.name">
                      <div class="relhidden">
                        <div  class="listCell">{{item.name | titlecase}}</div>
                      </div>
                    </small>
                  </li>

                  <li class="url">
                      <div class="relhidden">
                        <div class="listCell">{{item.pageType === 'EXTERNAL' ? item.externalUrl : item.url}}</div>
                      </div>
                  </li>

                  <li class="lastupdae">{{getNewTypeDate(item.lastModifiedDate)}}</li>

                  <li class="lastModifiedBy" [title]="item.lastModifiedByUserName">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.lastModifiedByUserName">{{item.lastModifiedByUserName | titlecase}}</div>
                    </div>
                  </li>


                  <li class="lastModifiedBy" [title]="item.pageType">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.pageType">{{item.pageType | titlecase}}</div>
                    </div>
                  </li>

                  <li class="lastModifiedBy lessWidth" [title]="item.storiesCount">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.storiesCount">{{item.storiesCount}}</div>
                    </div>
                  </li>

                  <li class="lastupdae">{{getDate(item.storiesCountLastUpdatedOn)}}</li>
                  <!--li class="lastModifiedBy" [title]="item.storiesCountLastUpdatedOn">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.storiesCountLastUpdatedOn"><span>{{getDate(item.storiesCountLastUpdatedOn)}}</span></div>
                    </div>
                  </li-->

                </a>

                <div *ngIf="!(accessType ==='View')" [class]="(togglePage === item.id) ? 'revertStoryBlock pagenavdrop active' : 'revertStoryBlock pagenavdrop'" id="page_{{item.id}}">
                  <ul>
                    <li><a href="/dash/page/nav-manager/{{item.id}}">Top Nav</a></li>

                    <li *ngIf="isSubNavEnabled"><a href="/dash/page/sub-nav-manager/{{item.id}}">Sub Nav</a></li>
                    <li><a href="/dash/page/{{item.id}}">Manage</a></li>
                  </ul>
                </div>
                <li class="relative pagemoredot" (click)="showNav(item.id)" *ngIf="item.pageType !== 'EXTERNAL'">
                  <span class="threedots"><span></span><span></span><span></span></span>
                </li>

              </ul>
            </div>

          </ng-container>
        </ng-container>
      </ng-template>
    </div>
  





  <div class="footerPagination">
    <!-- <ng-container>
      <button type="button" name="download" (click)="generateCSV()">Download dsd</button>
    </ng-container> -->
    <div class="pagination" *ngIf="totalRecords > 50">Page
      <ul>
        <ng-container *ngIf="7 > pages">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <!-- <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)"> -->
            <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            <!-- </ng-container> -->
          </ng-container>
        </ng-container>
        <ng-container *ngIf="pages > 6">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)">
              <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            </ng-container>
          </ng-container>
          <li>..</li>
          <li [class]="pageNum == (pages-1) ? 'active' : ''" (click)="onPageNumberChange(pages - 1)">{{(pages)}}</li>
        </ng-container>
      </ul>
    </div>

    <ng-container *ngIf="totalRecords < 50;then displayPaging else showPaging"></ng-container>
    <ng-template #showPaging>
      <div class="recordList">Showing
        <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
        </select>results of {{totalRecords}}
      </div>
    </ng-template>
    <ng-template #displayPaging>
      <div class="recordList borderNone">
        Showing {{totalRecords}} results</div>
    </ng-template>
  </div>


</div>

<ng-container *ngIf="load">
  <div class="loaderimage block">
    <div class="imagepreloader">
      <div class="a" style="--n: 5;">
        <div class="dot dot1" style="--i: 0;"></div>
        <div class="dot dot2" style="--i: 1;"></div>
        <div class="dot dot3" style="--i: 2;"></div>
        <div class="dot dot4" style="--i: 3;"></div>
      </div>
    </div>
  </div>
</ng-container>

<div class="lightBox readstory block" *ngIf="unlockPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Unlock Page</h3>
      <p>{{lockedUser}} will be able to view this page in read mode now.</p>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" name="cancel" (click)="cancelUnlock()" class="cancel gray mtb15 ml10">Cancel</button>
      <button type="button" name="unlock" (click)="unlockStory()" class="add blue mtb15 ml10 mr30">Unlock</button>
    </div>
  </div>
</div>
</div>
<div *ngIf="(accessType==='None')">
  <p>You do not have access.</p>
</div>